<template>
  <section class="what-we-think section" id="what-we-think">
    <div class="wrapper">
      <div class="row center-xs middle-xs top">
        <div class="col-md-4 col-sm-12 col-xs-12">
          <h2 class="title">O que pensamos</h2>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12"><span class="separator rotate"></span></div>
        <div class="col-md-7 col-sm-12 col-xs-12">
          <p class="text">{{api.o_que_pensamos_texto}}</p>
        </div>
      </div>
      <div class="row center-xs middle-xs">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <ul>
            <li
            :key="index"
            v-for="(link, index) in api.o_que_pensamos_links">
              <a :href="link.link" class="new">{{link.nome}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OQuePensamos',
  props: ['api'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  #what-we-think
    padding 190px 0 100px 0
    @media (max-width 640px)
      padding 130px 0 50px 0
    .separator
      left -15px
    .title
      text-align left
    .text
      text-align left
      font-size 16px
    .top
      margin-bottom 50px
    li
      padding 20px
      &:nth-child(even)
        background #F7F7F7
      a
        color #2699FB
        text-decoration underline
    @media (max-width 1250px)
      .separator
        display none
    @media (max-width 640px)
        .text, a
          font-size 14px
        .title
          text-align center
</style>



// WEBPACK FOOTER //
// src/components/WhatWeThinkSection.vue